const no = {
"front.faq.chat.title": "STILL ET SPØRSMÅL",
"front.faq.chat.description": "umiddelbar støtte for restaurantgjester",
"front.faq.chat.welcome": "Her kan du stille et spørsmål direkte.",
"front.faq.chat.placeholder": "melding",
"front.faq.chat.send": "send",
"front.faq.chat.unsupportedLanguage": "Beklager, denne chatten støtter for øyeblikket bare engelsk og tysk.",
"front.faq.chat.fallback": "Takk for meldingen din. For øyeblikket kan jeg bare svare på vanlige spørsmål. Ta kontakt med oss direkte for mer informasjon.",

"front.faq.chat.answer.hours": "Vi har åpent hver dag fra 10:00 til 22:00.",
"front.faq.chat.answer.reservation": "Ja, du kan reservere bord direkte på nettstedet vårt eller via telefon.",
"front.faq.chat.answer.groupReservation": "For gruppereservasjoner, vennligst kontakt oss direkte, så finner vi det beste alternativet for deg.",
"front.faq.chat.answer.address": "Adressen vår er: Musterstraße 1, Berlin.",
"front.faq.chat.answer.parking": "Ja, det finnes parkeringsmuligheter i nærheten.",
"front.faq.chat.answer.phone": "Du kan kontakte oss på +49 000 000000.",
"front.faq.chat.answer.payment": "Ja, hos oss kan du betale kontant eller med kort.",
"front.faq.chat.answer.menu": "Du finner vår oppdaterte meny på nettstedet. Hvis du har spørsmål om bestemte retter, hjelper vi deg gjerne.",
"front.faq.chat.answer.vegetarian": "Ja, vi tilbyr vegetariske retter.",
"front.faq.chat.answer.vegan": "Ja, vi har også veganske alternativer på menyen.",
"front.faq.chat.answer.allergens": "Hvis du har allergier eller intoleranser, vennligst kontakt oss direkte. Vi gir deg gjerne informasjon om ingrediensene.",
"front.faq.chat.answer.takeaway": "Ja, mat kan også bestilles som takeaway.",
"front.faq.chat.answer.delivery": "For øyeblikket støtter vi bare reservasjoner og spørsmål via nettstedet.",
"front.faq.chat.answer.terrace": "Ja, i fint vær kan du også sitte på terrassen vår.",
"front.faq.chat.answer.pets": "Ta kontakt med oss direkte hvis du ønsker å komme med kjæledyr.",
"front.faq.chat.answer.children": "Ja, familier med barn er hjertelig velkomne hos oss.",
"front.faq.chat.answer.wifi": "Ja, Wi-Fi er tilgjengelig for våre gjester.",

"front.acquaintance.callback.placeholder": "Telefonnummeret ditt",
"front.acquaintance.callback.send": "Send",
"front.acquaintance.callback.sending": "Sender...",
"front.acquaintance.callback.invalidPhone": "Vennligst skriv inn et gyldig telefonnummer.",
"front.acquaintance.callback.success": "Forespørselen er sendt. Jeg kontakter deg snart.",
"front.acquaintance.callback.error": "Feil ved sending av forespørselen. Prøv igjen.",

"front.landingSeo.links.digitalMenu": "Digital meny for restauranter",
"front.landingSeo.links.qrMenu": "QR-kode-meny for restauranter",
"front.landingSeo.links.multilingualMenu": "Flerspråklig meny for restauranter",
"front.landingSeo.links.reservation": "Online bordreservasjon for restauranter",
"front.landingSeo.links.freeDigitalMenu": "Test en gratis digital meny",
"front.landingSeo.links.changeMenuOnline": "Endre meny online",

"menu.title": "Meny",
"menu.promo": "Spesialtilbud",
"menu.empty.categoryTitle": "Fyll inn kategorinavn",
"menu.empty.itemTitle": "Fyll inn produktnavn",
"menu.empty.itemDescription": "Fyll inn produktbeskrivelse",
"cart.add": "Legg i handlekurv",
"cart.cancel": "Avbryt",
"section.video": "Videopresentasjon",
"section.tables": "ONLINE BORDRESERVASJON",
"section.table": "VELG ET BORD",
"section.menu": "Restaurantmeny",
"section.faq": "FAQ",
"section.contact": "Kontakt",
"promo.buy": "Kjøp",

"front.tenant.resolving": "Finner restaurant via underdomene…",
"front.tenant.notFound": "Ingen kunde funnet for dette underdomenet",
"front.tenant.resolveError": "Kunne ikke finne kunden",
"front.menu.loading": "Laster…",
"front.menu.loadError": "Kunne ikke laste menyen",
"front.menu.addtocart": "Handlekurv",
"front.menu.cancel": "Avbryt",
"front.Number.servings": "Antall porsjoner",

"orbit.menu": "MENY",
"orbit.shef": "RESERVASJON",
"orbit.video": "VIDEO",
"orbit.faq": "SPØRSMÅL",
"orbit.interior": "INTERIØR",
"orbit.footer": "SOSIALE MEDIER",

"shef.title.line1": "ONLINE",
"shef.title.line2": "RESERVASJON",
"shef.banner.label": "Velg",
"shef.banner.main": "bordet ditt",
"shef.reserved": "RESERVERT",

"video.title": "SLIK LAGER VI MAT — ÆRLIG OG SMAKFULLT",
"video.add": "Legg til video",
"add.video.but": "Legg til",

"interior.title": "VÅRT INTERIØR",

"footer.kontact": "KONTAKTER",

"telegram.title": "For å sette opp Telegram-varsler for bestillinger må du:",
"telegram.title.first": "1. Hente BOT_TOKEN",
"telegram.text.first": "For å få et BOT_TOKEN, finn og start @BotFather-boten i Telegram, send kommandoen /newbot, følg instruksjonene for å opprette et unikt botnavn og brukernavn, og kopier deretter API-tokenet som @BotFather sender som svar.",
"telegram.title.two": "2. Hente CHAT_ID",
"telegram.text.two": "For å få CHAT_ID, finn og start @UserInfoBot-boten i Telegram, send kommandoen /start og kopier deretter ID-en du mottar i svarmeldingen.",

"cart.title": "DIN HANDLEKURV",
"cart.header.aria": "Din handlekurv",
"cart.toggle.expand": "Utvid handlekurv",
"cart.toggle.collapse": "Skjul handlekurv",
"cart.total.label": "Totalt",
"cart.total.products": "produkter",
"cart.button.primary": "bestill",
"cart.button.back": "tilbake",
"cart.button.waiter": "SERVITØR",

"cart.mode.takeaway": "takeaway",
"cart.mode.tableTime": "Tid og bord",
"cart.mode.tableTime.disabled": "ingen ledige bord",
"cart.mode.tableTime.tooltip": "Tid og bord",
"cart.mode.tableTime.tooltipNoFree": "ingen ledige bord",
"cart.mode.inHouse": "på stedet",

"cart.bookingFlow.title": "RESERVASJON. BORDNUMMER",
"cart.deposit.itemTitle": "Bordreservasjon (depositum)",
"cart.deposit.lineTitle": "Depositum",
"cart.deposit.badge": "Depositum {amount}€",

"cart.table.msg.tempChosen": "Bord {table} er midlertidig valgt ✓",
"cart.table.msg.noFree": "Dessverre finnes det ingen ledige bord",
"cart.table.msg.chooseOrDefault": "Vennligst velg et bord eller bruk standardvalget.",

"cart.table.select.reserved": "RESERVERT",
"cart.table.select.pick": "VELG",
"cart.table.select.any": "VALGFRITT",

"cart.inHouse.title": "VELG BORDNUMMER",
"cart.inHouse.select.placeholder": "Velg bord",
"cart.inHouse.select.option": "Bord #{n}",

"cart.checkout.back": "Tilbake",
"cart.payment.preparing": "Forbereder betaling…",
"cart.loading": "Laster…",

"mockCheckout.title.paymentMethod": "BETALINGSMETODE",
"mockCheckout.method.card": "Bankkort",
"mockCheckout.method.paypal": "PayPal",
"mockCheckout.method.gpay": "Google Pay",
"mockCheckout.cardForm.title": "SKRIV INN KORTOPPLYSNINGER",
"mockCheckout.cardForm.numberLabel": "KORTNUMMER",

"mockCheckout.error.invalidCardNumber": "Ugyldig kortnummer",
"mockCheckout.error.enter16Digits": "Skriv inn 16 sifre",
"mockCheckout.error.expiryFormat": "Format MM/ÅÅ",
"mockCheckout.error.expiryMonthRange": "Måned 01–12",
"mockCheckout.error.cardExpired": "Kortet er utløpt",
"mockCheckout.error.cvc3Digits": "3 sifre",

"mockCheckout.error.sendTelegram": "Feil ved sending til Telegram",
"mockCheckout.error.generic": "Noe gikk galt",

"mockCheckout.reserve.clientNotFound": "Kunde ikke funnet",
"mockCheckout.reserve.tablesNotFound": "Denne kunden har ingen bordseksjon",
"mockCheckout.reserve.tableNotFound": "Bord ikke funnet",
"mockCheckout.reserve.alreadyReserved": "Dette bordet ble nettopp tatt. Velg et annet.",
"mockCheckout.reserve.noFreeTables": "Det finnes ingen ledige bord akkurat nå",
"mockCheckout.reserve.tableNotSelected": "Vennligst velg et bord",
"mockCheckout.reserve.genericError": "Reservasjonsfeil",

"mockCheckout.button.back": "tilbake",
"mockCheckout.button.pay": "BETAL",
"mockCheckout.button.sending": "…sender",
"mockCheckout.button.paid": "...",
"mockCheckout.button.payInvalidTitle": "Kontroller kortopplysningene",

"admin.booking.lead.title": "MINIMUMSTID FØR RESERVASJON",
"admin.booking.lead.note": "Dette gjelder bare gjestereservasjoner i modusen “bord og tid”. Intervallet er 30 minutter.",

"dateTimeStep.select.time": "VELG TID",

"admin.title": "ADMINPANEL",
"admin.loading": "Laster…",
"admin.nav.delete": "Slett",
"admin.nav.back": "Tilbake",
"admin.nav.next": "NESTE",
"admin.nav.confirm": "LAGRE",
"admin.nav.confirm.now": "lagrer ...",
"admin.booking.settings": "Reservasjonsinnstillinger",
"admin.booking.deposit": "DEPOSITUMSBELØP",
"admin.booking.deposit.note": "Depositum belastes når gjesten bare reserverer et bord",

"admin.hub.editmenu": "REDIGER MENY",
"admin.hub.qr": "QR-KODE",
"admin.hub.prices": "DIN PLAN",
"admin.hub.settings": "INNSTILLINGER",

"admin.panel.editmenu": "Rediger meny",
"admin.validation.required": "Obligatorisk felt",
"admin.panel.add": "Legg til posisjon",
"admin.panel.menu": "Rediger menyliste",
"admin.panel.telegram": "Telegram",
"admin.panel.table": "BORDADMINISTRASJON",
"admin.set.table": "Saler / bord",
"admin.set.logo": "Logo og bakgrunner",
"admin.logo.successfully.applied": "Logoen ble tatt i bruk",
"admin.logo.download.error": "Nedlastingsfeil",
"admin.settings.number.rooms": "Antall saler",
"admin.settings.room": "Sal",

"admin.qr.title": "QR-kode for gjester",
"admin.qr.alt": "QR for restaurant",
"admin.qr.copy": "kopier lenke",
"admin.qr.copied": "✓ kopiert",
"admin.qr.note": "Gjester kan skanne denne koden for å åpne siden din umiddelbart.",

"admin.link.notfound": "Lenke ikke funnet",
"admin.table.info": "Bordadministrasjon er tilgjengelig på denne siden. Status endres ved å trykke på bordet.",
"admin.prices.temp": "Priser er midlertidig utilgjengelige.",
"admin.forgot.password": "Glemt passord?",
"admin.success.description": "Klikk OK og legg til et nytt produkt",

"order.success": "Varen er lagt i handlekurven!",
"order.error": "Denne varen ligger allerede i handlekurven",

"popap.product.removal": "Fjerning av produkt",
"popap.category.removal": "Fjerning av kategori",
"popap.want.delete.product": "Er du sikker på at du vil slette produktet",
"popap.want.delete.category": "Er du sikker på at du vil slette kategorien?",

"admin.settings.guestLang": "Standardspråk for gjester",
"admin.settings.adminLang": "Standardspråk for admin",
"admin.settings.noteGuest": "Dette språket blir satt som standard når gjester åpner siden.",
"admin.settings.noteAdmin": "Dette språket blir satt som standard i adminpanelet.",
"admin.language": "Språk",
"admin.settings.logo": "Restaurantens logo",
"admin.settings.logo.text": "Last opp logoen din (PNG/JPG/WEBP/SVG, opptil 2 MB). Klikk deretter på “Lagre”; den nåværende logoen blir erstattet med den nye.",
"admin.settings.backtable": "Bakgrunnsbilde på skjermen for valg av bord",
"admin.settings.backhome": "Bakgrunnsbilde på startskjermen",
"admin.settings.backtable.text": "Last opp et bakgrunnsbilde (SVG/PNG/JPG/WEBP). Klikk deretter på “Lagre”; den nåværende bakgrunnen blir erstattet med den nye.",
"admin.settings.language.visitors": "Hovedspråk for restaurantens besøkende",
"admin.settings.language.visitors.text": "Dette språket blir satt som hovedspråk når gjester åpner siden",
"admin.settings.language.admin": "Hovedspråk for adminpanelet ditt",
"admin.settings.language.admin.text": "Dette språket blir satt som standard når adminpanelet åpnes",
"admin.settings.gallery": "Galleri",
"admin.settings.social": "Sosiale nettverk",
"admin.settings.number.tables": "Antall bord",
"admin.settings.how.many.tables": "Hvor mange bord finnes det i restauranten?",
"admin.settings.tables.test": "Lagre antall bord og gå tilbake til forrige fane for å konfigurere hvert bord separat.",
"admin.settings.upload.panoramic": "Last opp et panoramabilde av salen i restauranten din",
"admin.settings.table": "Bord",
"admin.settings.table.not.found": "Bord ikke funnet",
"admin.settings.contact.details": "Kontaktopplysninger",
"admin.contacts.company": "Firmanavn",
"admin.contacts.address": "Adresse",
"admin.contacts.phone": "Telefonnummer",
"admin.socials.title": "Sosiale medier",
"admin.settings.rooms.hint": "Oppgi antall saler i restauranten",

"admin.settable.title": "Trinn 3. Bordnummerering",
"admin.settable.text1": "Hver etikett har et nummer; plasser etikettene i henhold til bordnumrene.",
"admin.settable.text2": "Bruk bryteren for å endre etikettstørrelsen.",
"admin.settable.text3": "Lagre dataene for det aktuelle bordet og klikk på det tilsvarende ikonet for å bytte mellom bord.",
"admin.setqr.title": "Dine QR-koder",
"admin.setqr.text1": "på denne siden lagres meldinger, menyer og QR-koder",
"admin.setqr.text2": "ved kjøp av BASIC-planen genereres det automatisk en QR-kode og en lenke til underdomenet ditt (for eksempel example.best-place.club)",
"admin.setqr.text3": "du kan åpne lenken, kopiere den og også lagre QR-koden som et bilde på enheten din",
"admin.setpanorama.title": "Trinn 2. Panoramabilde",
"admin.setpanorama.text1": "Legg til et panoramabilde. Det anbefales å bruke lette filer, for eksempel WEBP-format.",
"admin.setpanorama.text2": "Hvis bildet er lastet opp riktig, ser du det i forhåndsvisningen nedenfor.",
"admin.setnumber.title": "Trinn 1. Antall bord",
"admin.setnumber.text1": "Velg antall bord i restauranten din",
"admin.setnumber.text2": "Det anbefales å starte oppsettet med ett eller to bord og deretter øke antallet.",

"admin.current.logo": "Nåværende logo",
"admin.add.photo": "her kan du legge til en fil",
"admin.add.file": "filformater for opplasting: .xlsx, .xls, .csv",
"admin.add.file.but": "Legg til fil",
"admin.import.format": "Kolonneformat: Kategori / Tittel / Beskrivelse / Pris",
"admin.import.follow": "følg det angitte kolonneformatet og klargjør en fil i tilsvarende format",
"admin.import.BeСareful": "Merk: tidligere data går tapt under import",
"admin.add.photo.but": "Legg til bilde",
"admin.add.photo.set": "Legg til bilde",

"admin.wizard.step1": "Velg kategori",
"admin.wizard.step2": "Navn og pris",
"admin.wizard.step3": "Beskrivelse og bilde",
"admin.wizard.ready": "Ferdig",
"admin.wizard.defaultTitle": "Legg til produkt",
"admin.wizard.step1.desc": "Trinn 1. Velg en eksisterende kategori eller opprett en ny",
"admin.wizard.step2.desc": "Trinn 2. Velg et navn for produktet og sett en pris",
"admin.wizard.step3.desc": "Trinn 3. Skriv en produktbeskrivelse, legg til et bilde og klikk lagre",
"admin.wizard.step1.desc.short": "Trinn 1. Velg en eksisterende eller ny kategori",
"admin.wizard.step2.desc.short": "Trinn 2. Legg til produktnavn og pris",
"admin.wizard.step3.desc.short": "Trinn 3. Beskriv produktet og legg til et bilde",

"admin.wizard.tab.existing": "Eksisterende",
"admin.wizard.tab.new": "Ny",
"admin.wizard.cat.loading": "Laster…",
"admin.wizard.cat.empty": "Det finnes ingen kategorier ennå. Bytt til “Ny” og opprett den første.",

"admin.form.categoryKeyDe": "Kategori (KEY/NO)",
"admin.form.categoryEn": "Kategori (EN)",
"admin.form.titleMain": "Produktnavn",
"admin.form.descMain": "Produktbeskrivelse",
"admin.validation.req": "Skriv inn produktnavn",
"admin.form.titleDe": "Tittel (DE)",
"admin.form.titleEn": "Tittel (EN)",
"admin.form.nameDe": "Navn (DE)",
"admin.form.nameEn": "Navn (EN)",
"admin.form.price": "Pris",
"admin.form.descDe": "Beskrivelse (DE)",
"admin.form.descEn": "Beskrivelse (EN)",

"admin.toast.productAdded": "Produktet ble lagt til",
"admin.tooltip.fixFormErrors": "Rett feilene i skjemaet",

"admin.validation.firstCharNotDigit": "Det første tegnet kan ikke være et tall.",
"admin.validation.maxChars": "forkort produktnavnet",
"admin.validation.chooseCategory": "Velg en kategori.",
"admin.validation.chooseCategoryFromList": "Velg en kategori fra listen.",
"admin.validation.enterCategoryName": "Skriv inn et kategorinavn.",
"admin.validation.enterProductName": "Skriv inn et produktnavn.",
"admin.validation.priceFormat": "Ugyldig prisformat (f.eks. 12.50)",
"admin.validation.enterDescription": "Skriv inn en beskrivelse.",
"admin.tarif.apply": "bruk",
"admin.menu.creating": "Opprett meny",
"admin.choose.template": "Trinn 1: Velg en mal",
"admin.choose.template2": "Trinn 2: Kontroller produktlinjene",
"admin.choose.atyle": "Velg en menystil. Du kan endre den senere",

"admin.error.tenantNotFound": "Ingen kunde funnet for dette underdomenet.",
"admin.error.resolveClient": "Kunne ikke finne kunden.",
"admin.error.menuLoad": "Kunne ikke laste menyen.",
"admin.error.saveLang": "Kunne ikke lagre språket.",
"admin.error.clientNotFound": "Kunde ikke funnet på serveren",
"admin.error.arrNotFound": "Dataarray ble ikke funnet for denne kunden",

"tpl.premium.title": "Premium",
"tpl.classic.title": "Klassisk",
"tpl.dark.title": "Mørk",
"tpl.minimal.title": "Minimalistisk",
"tpl.premium.desc": "Bestselger",
"tpl.classic.desc": "lys",
"tpl.dark.desc": "mørk",
"tpl.minimal.desc": "minimalistisk",

"tp2.position.total": "Du har nå:",
"tp2.position.punkte": "Menyelementer",
"tp2.position.template": "Mal",

"tp3.qr.link": "QR-kode og menylenke",
"tp3.step3.title": "Trinn 3: Forhåndsvisning / Publisering",
"admin.tp.progres.publication": "Publisering",
"admin.tp.progres.positionen": "Posisjon",

"tp4.link.copy": "KOPIER",
"tp4.link.copy.ok": "✓ KOPIERT",

"admin.tp.publish": "Publiser",
"admin.tp.posting": "publiserer ...",

"admin.import.from.excel": "Importer meny fra Excel",

"popap.successful.payment": "Betaling fullført",

"landing.title": "Digitale løsninger for restauranter",
"landing.title.login": "Logg inn",
"landing.text": "Lanser restaurantnettstedet ditt på få minutter!",
"landing.try.now": "prøv gratis",
"landing.title.to": "Hvem passer tjenesten vår for?",
"landing.title.answer": "Først og fremst er den nyttig for eiere av serveringssteder som ønsker å tiltrekke nye kunder og beholde eksisterende",
"landing.content.title.first": "Online meny med QR-kode",
"landing.content.first": "Gjestene dine kan stole på en oppdatert meny og aktuelle priser ved ganske enkelt å skanne QR-koden. Spesialtilbud øker gjestenes lojalitet til produktet ditt",
"landing.content.title.second": "Online bordreservasjoner",
"landing.content.second": "Vi tilbyr gjestene en visuell online bordreservasjon med ekstra panoramabilder. Ved behov kan de bytte mellom nærliggende soner",
"landing.content.title.third": "Stemningsfullt innhold",
"landing.content.third": "Potensielle gjester kan se ulike typer innhold: bilder av interiøret, videoer av tilberedningen av toppretter og panoramautsikt over salen.",
"landing.content.title.four": "Øk gjennomsnittlig regning",
"landing.content.four": "Tilby gjestene dine arrangementer som banketter, bursdager eller spesialtilbud for større eller daglige bestillinger",
"landing.request": "Vi kontakter deg snart",
"callback.invalidPhone": "Skriv inn et gyldig telefonnummer",
"landing.enter.number": "DITT NUMMER",
"callback.submitError": "Nummeret kunne ikke sendes. Prøv igjen",
"landing.tariff.advance": "Advarsel",
"landing.tariff.advance.desc": "Innenfor den valgte planen kan du fylle applikasjonen din med innhold gratis",
"landing.tariff.one-time-not-included": "Individuell prisberegning. I høyre hjørne av skjermen finner du en kontaktknapp. Legg igjen nummeret ditt, så kontakter vi deg",
"landing.tariff.one-time-services": "Engangstjenester",
"landing.tariff.logo-creation": "Logoopprettelse",
"landing.tariff.selling-images": "Salg av produktbilder",
"landing.tariff.panorama-creation": "Opprettelse av panorama",

"demo.video.unsupported": "Nettleseren din støtter ikke video",
"demo.title.after": "oversikt over tjenesten",
"demo.title.accent": "kort",
"demo.title.before": "En",
"demo.title.total": "om tjenesten",
"demo.title": "Videooversikt",

"landing.free.first": "Online meny via QR-kode tilgjengelig, resultat på få minutter.",
"landing.free.second": "Mulighet til å redigere menyen for gjeldende dato",
"landing.free.third": "Tilgang til menydesigneren",
"landing.basic.first": "En full URL-side med tilgang til menyen via QR-kode",
"landing.basic.second": "Nettbestilling for dine besøkende",
"landing.basic.third": "Online bordreservasjoner, panoramabilder av spisesalen, klikkbare bord og sanntidsvisning av reserverte og ledige bord",
"landing.basic.fourth": "Meny med oversettelse til alle språk",
"landing.pro.first": "Funksjonalitet som lar deg administrere pristilbud, lage bannere og markedsføringsstrategier",
"landing.pro.second": "Mulighet til å administrere gjestelojalitetssystemet og påvirke sluttresultatet av Google-anmeldelser",
"landing.pro.third": "",
"landing.title.free": "Gratis i 14 dager",
"landing.registerTitle": "Registrering",
"landing.tariff.selection": "Valg av plan",
"landing.tariff.subdomain": "Registrering av underdomene",
"landing.tariff": " / per måned",
"landing.your.tariff": "din plan",
"landing.your.example": "for eksempel",
"landing.Subdomain.selection": "Valg av underdomene",
"landing.password": "passord",
"landing.tariff.free": "GRATIS",
"landing.tariff.free-description": "for å bli kjent med tjenesten",
"landing.tariff.basic": "BASIC",
"landing.tariff.basic-description": "grunnleggende funksjoner for å komme i gang",
"landing.tariff.pro": "PRO",
"landing.tariff.pro-description": "For avanserte brukere",
"landing.tariff.selected": "✓ valgt",
"landing.legal.text.start": "Jeg godtar",
"footer.legal.terms": "Vilkår",
"landing.legal.text.mid": "og",
"landing.tariff.optional": "Engangstjenester",
"landing.tariff.one-time-note": "Se priser for å lage salgsorienterte bilder av høy kvalitet",
"landing.tariff.pro-locked-desc": "Denne planen er ikke tilgjengelig ennå",
"landing.tariff.in-development": "Under utvikling",
"landing.tariff.free-one-time-desc": "for å fylle publikasjonen din med bilder av høy kvalitet",

"footer.legal.privacy": "Personvern",
"footer.legal.privacy.and": "policy",
"footer.about": "Plattform for restauranter: meny, bordreservasjoner, bestillinger og adminpanel.",

"server.common.unknown": "Ukjent feil.",
"server.common.serverError": "Intern serverfeil.",
"server.common.networkError": "Nettverksfeil. Prøv igjen.",
"server.common.clientIdMissing": "Feil: clientId mangler.",

"server.login.required": "E-post og passord er påkrevd.",
"server.login.invalidCredentials": "Ugyldig e-post eller passord.",
"server.login.signupIncomplete": "Kontoen er ikke aktiv ennå. Fullfør registreringen.",
"server.login.success": "Innlogging fullført!",

"server.register.required": "E-post og passord er påkrevd.",
"server.register.emailExistsActive": "Det finnes allerede en bruker med denne e-posten. Bruk Login.",
"server.register.resume": "Fortsetter registrering.",
"server.register.success": "Registrering fullført!",

"server.signupComplete.success": "Aktivering fullført!",
"server.signupComplete.error": "Aktivering mislyktes.",

"server.subdomain.required": "clientId og underdomene er påkrevd.",
"server.subdomain.planInvalid": "Ugyldig plan. Tillatt: free | basic | pro.",
"server.subdomain.invalid": "Ugyldig underdomene (a-z, 0-9, '-', 3–30, uten '-' i starten/slutten).",
"server.subdomain.reserved": "Dette underdomenet er reservert.",
"server.subdomain.taken": "Dette underdomenet er allerede opptatt.",
"server.subdomain.userNotFound": "Bruker ikke funnet.",
"server.subdomain.success": "Underdomene registrert. Omdirigerer…",
"server.subdomain.error": "Registrering av underdomene mislyktes.",

"landing.loginTitle": "Login",
"landing.btn.login": "Login",
"landing.btn.register": "Registrering",
"landing.btn.enter": "Gå inn",
"landing.loggingIn": "Logger inn…",
"landing.registering": "Registrerer…",
"landing.activating": "Aktiverer…",
"landing.subdomain.registering": "Registrerer underdomene…",
"landing.redirecting": "Omdirigerer…",
"landing.legal.required": "Vennligst godta vilkår og personvernerklæring.",

"landing.subdomain.err.empty": "Skriv inn et underdomene.",
"landing.subdomain.err.chars": "Bare bokstaver, tall og '-', 3–30 tegn.",
"landing.subdomain.err.hyphen": "Underdomenet kan ikke starte eller slutte med '-'.",
"landing.subdomain.err.reserved": "Dette underdomenet er reservert.",

"admin.menuLanguages.title": "Menyspråk",
"admin.menuLanguages.default": "Språket som en besøkende til virksomheten din vil se først (som standard)",
"admin.menuLanguages.hint": "Velg språkene som skal brukes i tillegg",
"common.success": "Vellykket",
"admin.import.activeLangs": "Aktive menyspråk",
"admin.import.sourceLangHint": "Excel vil kun bli skrevet på det valgte språket. Andre aktive språk vil forbli tomme.",
"admin.import.sourceLang": "Angi språket som Excel-filen er skrevet på",
"admin.import.mainLang": "det viktigste",
"booking.date.today": "I dag",
  "booking.date.tomorrow": "I morgen",
  "booking.room": "Rom",

  "front.faq.chat.answer.greeting": "Hei! Jeg kan hjelpe med reservasjoner, meny, adresse, åpningstider og andre spørsmål.",
"front.faq.chat.answer.howAreYou": "Takk, jeg har det bra! Hvordan kan jeg hjelpe deg med restauranten?",
"front.faq.chat.answer.thanks": "Bare hyggelig! Skriv gjerne hvis du har flere spørsmål.",
"front.faq.chat.answer.goodbye": "Ha det! Vi gleder oss til besøket ditt.",
"front.faq.chat.answer.whoAreYou": "Jeg er restaurantens digitale assistent. Jeg hjelper gjester med vanlige spørsmål.",
"front.faq.chat.answer.help": "Jeg kan hjelpe med reservasjoner, meny, adresse, telefonnummer, betaling, allergener, levering og andre spørsmål.",
"front.faq.chat.answer.recommendation": "Jeg anbefaler å se på menyen — der finner du de aktuelle rettene og kan velge det som passer deg best.",
"front.faq.chat.answer.compliment": "Tusen takk! Det er hyggelig å høre.",

"checkout.button.send": "SEND",
"checkout.button.sending": "Sender ...",
"checkout.button.sent": "Sendt",
"checkout.title.order": "BESTILLING",
"checkout.phone.title": "Skriv inn telefonnummeret ditt",
"checkout.phone.label": "Telefonnummer",

"footer.workingHours": "Arbeidstid",

"admin.offline.title": "Ingen internettforbindelse",
"admin.offline.text": "Sjekk internettforbindelsen. Du kan automatisk fortsette arbeidet når forbindelsen er gjenopprettet.",
"admin.offline.status": "Venter på tilkobling…",


};

export default no;
